import useApi, { MyClubCApi } from '../../../api';
import React from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import Loading from '../../../components/Loading';
import { t } from 'ttag';
import { BASE_STATUS, BASE_STATUS_TITLES } from '../../../utils/enums';
import Grid from '@material-ui/core/Grid';
import DataTable from '../../../components/DataTable';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import MainIcon from '@material-ui/icons/Beenhere';
import Link from '@material-ui/core/Link';

export const AdditionTab = ({ trainerId }) => {
  const api = useApi();
  const [loading, setLoading] = React.useState(false);
  const [groups, setGroups] = React.useState([]);
  const [athletes, setAthletes] = React.useState([]);
  const client = useApolloClient();
  const newApi = new MyClubCApi(client);

  const fetchPageData = async () => {
    setLoading(true);
    const groupsRes = await newApi.getGroups({ trainerId: trainerId });
    setGroups(groupsRes);
    const athletesRes = await newApi.getAthletes({
      mainTrainerId: trainerId,
    });
    setAthletes(athletesRes);
    setLoading(false);
  };

  React.useEffect(() => {
    fetchPageData();
  }, []);

  if (loading) return <Loading />;

  return (
    <Grid container>
      <Grid item sm={12} style={{ marginTop: '20px' }}>
        <DataTable
          isLoading={loading}
          title={t`Список групп`}
          pageSize={5}
          columns={[
            { title: t`Id`, field: 'id', editable: 'never' },
            {
              title: t`Назва`,
              field: 'name',
              render: (r) => {
                return (
                  <Link target='_blank' href={api.router.groups.edit(r.id)}>
                    {r.name}
                  </Link>
                );
              },
            },
            {
              title: t`Вид спорту`,
              field: 'section',
              render: ({ sectionObj }) => (sectionObj && sectionObj.name) || '',
            },
            {
              title: t`Зал`,
              field: 'gym_id',
              render: ({ gym }) => (gym && gym.name) || '',
            },
            {
              title: t`Тренер`,
              field: 'trainer',
              render: ({ trainer }) => {
                return (
                  <Link
                    target='_blank'
                    href={api.router.trainers.edit(trainer.id)}
                  >
                    {trainer.fullName}
                  </Link>
                );
              },
            },
            { title: t`Спортсменів`, field: 'countAthletes' },
            {
              title: t`Статус`,
              field: 'status',
              render: ({ status }) => BASE_STATUS_TITLES[status],
            },
          ]}
          data={groups}
        />
      </Grid>
      <Grid item sm={12} style={{ marginTop: '20px' }}>
        <DataTable
          isLoading={loading}
          title={t`Список спортсменів`}
          pageSize={5}
          columns={[
            { title: t`Id`, field: 'id', editable: 'never' },
            {
              title: t`ПІБ`,
              field: 'fullName',
              editable: 'never',
              render: (r) => {
                return (
                  <Link target='_blank' href={api.router.athletes.edit(r.id)}>
                    {r.fullName}
                  </Link>
                );
              },
            },
            {
              title: t`Зал`,
              field: 'gyms',
              render: ({ gyms }) =>
                gyms.map((g) => (
                  <Chip
                    key={g.id}
                    variant='outlined'
                    size='small'
                    label={g.name}
                  />
                )),
            },
            {
              title: t`Спорт`,
              field: 'sections',
              render: ({ sections }) =>
                sections.map((s) => (
                  <Chip
                    key={s.id}
                    variant='outlined'
                    size='small'
                    label={s.name}
                  />
                )),
            },
            {
              title: t`Тренер`,
              field: 'trainers',
              editable: 'never',
              render: ({ trainers, mainTrainerId }) =>
                trainers.map((trainer) => (
                  <Chip
                    key={trainer?.id}
                    variant='outlined'
                    size='small'
                    label={trainer?.fullInitials}
                    color='primary'
                    icon={
                      mainTrainerId === trainer?.id ? (
                        <Tooltip title={t`Головний тренер`}>
                          <MainIcon />
                        </Tooltip>
                      ) : null
                    }
                    onClick={() => {
                      window.open(api.router.trainers.edit(trainer.id));
                    }}
                  />
                )),
            },
            {
              title: t`Статус`,
              field: 'status',
              render: ({ status }) => {
                const colorMap = {
                  [BASE_STATUS.blocked]: 'secondary',
                  [BASE_STATUS.active]: 'primary',
                };
                return (
                  <Chip
                    size='small'
                    label={BASE_STATUS_TITLES[status]}
                    color={colorMap[status] || 'default'}
                    variant='default'
                  />
                );
              },
            },
          ]}
          data={athletes}
        />
      </Grid>
    </Grid>
  );
};
